import { getChannelAPIPath } from '@treasury/core/http';

CheckImageService.$inject = ['$resource'];

export default function CheckImageService($resource) {
    return {
        getDepositSet,
        getCheckImage,
    };

    function getDepositSet(depositImageNumber) {
        return $resource(`${getChannelAPIPath()}checkimages/deposit`, {
            depositImageNumber,
        }).query().$promise;
    }

    function getCheckImage(checkImageNumber) {
        return $resource(
            `${getChannelAPIPath()}checkimages/check`,
            { checkImageNumber },
            { get: { method: 'GET', isArray: false } }
        ).get().$promise;
    }
}
